"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BspEntityParser = exports.RenderMode = exports.RenderEffect = exports.ZHLTLightFlags = exports.EnvBeamSpawnFlags = exports.CyclerWeaponTriggerCondition = exports.ButtonTargetSpawnFlags = exports.AmbientGenericSpawnFlags = exports.AmbientGenericPreset = exports.AiScriptedSequenceSpawnflags = exports.AiScriptedSequenceFinishSchedule = exports.AiScriptedSequenceMoveTo = exports.WorldSpawnDefaultTeam = exports.WorldSpawnNewUnit = exports.WorldSpawnGameTitle = exports.WorldSpawnStartDark = void 0;
var WorldSpawnStartDark;
(function (WorldSpawnStartDark) {
    WorldSpawnStartDark[WorldSpawnStartDark["No"] = 0] = "No";
    WorldSpawnStartDark[WorldSpawnStartDark["Yes"] = 1] = "Yes";
})(WorldSpawnStartDark || (exports.WorldSpawnStartDark = WorldSpawnStartDark = {}));
var WorldSpawnGameTitle;
(function (WorldSpawnGameTitle) {
    WorldSpawnGameTitle[WorldSpawnGameTitle["No"] = 0] = "No";
    WorldSpawnGameTitle[WorldSpawnGameTitle["Yes"] = 1] = "Yes";
})(WorldSpawnGameTitle || (exports.WorldSpawnGameTitle = WorldSpawnGameTitle = {}));
var WorldSpawnNewUnit;
(function (WorldSpawnNewUnit) {
    WorldSpawnNewUnit[WorldSpawnNewUnit["No"] = 0] = "No";
    WorldSpawnNewUnit[WorldSpawnNewUnit["Yes"] = 1] = "Yes";
})(WorldSpawnNewUnit || (exports.WorldSpawnNewUnit = WorldSpawnNewUnit = {}));
var WorldSpawnDefaultTeam;
(function (WorldSpawnDefaultTeam) {
    WorldSpawnDefaultTeam[WorldSpawnDefaultTeam["FewestPlayers"] = 0] = "FewestPlayers";
    WorldSpawnDefaultTeam[WorldSpawnDefaultTeam["FirstTeam"] = 1] = "FirstTeam";
})(WorldSpawnDefaultTeam || (exports.WorldSpawnDefaultTeam = WorldSpawnDefaultTeam = {}));
var AiScriptedSequenceMoveTo;
(function (AiScriptedSequenceMoveTo) {
    AiScriptedSequenceMoveTo[AiScriptedSequenceMoveTo["No"] = 0] = "No";
    AiScriptedSequenceMoveTo[AiScriptedSequenceMoveTo["Walk"] = 1] = "Walk";
    AiScriptedSequenceMoveTo[AiScriptedSequenceMoveTo["Run"] = 2] = "Run";
    AiScriptedSequenceMoveTo[AiScriptedSequenceMoveTo["Instantaneous"] = 4] = "Instantaneous";
    AiScriptedSequenceMoveTo[AiScriptedSequenceMoveTo["No_TurnToFace"] = 5] = "No_TurnToFace";
})(AiScriptedSequenceMoveTo || (exports.AiScriptedSequenceMoveTo = AiScriptedSequenceMoveTo = {}));
var AiScriptedSequenceFinishSchedule;
(function (AiScriptedSequenceFinishSchedule) {
    AiScriptedSequenceFinishSchedule[AiScriptedSequenceFinishSchedule["DefaultAI"] = 0] = "DefaultAI";
    AiScriptedSequenceFinishSchedule[AiScriptedSequenceFinishSchedule["Ambush"] = 1] = "Ambush";
})(AiScriptedSequenceFinishSchedule || (exports.AiScriptedSequenceFinishSchedule = AiScriptedSequenceFinishSchedule = {}));
var AiScriptedSequenceSpawnflags;
(function (AiScriptedSequenceSpawnflags) {
    AiScriptedSequenceSpawnflags[AiScriptedSequenceSpawnflags["Repeatable"] = 4] = "Repeatable";
    AiScriptedSequenceSpawnflags[AiScriptedSequenceSpawnflags["LeaveCorpse"] = 8] = "LeaveCorpse";
})(AiScriptedSequenceSpawnflags || (exports.AiScriptedSequenceSpawnflags = AiScriptedSequenceSpawnflags = {}));
var AmbientGenericPreset;
(function (AmbientGenericPreset) {
    AmbientGenericPreset[AmbientGenericPreset["None"] = 0] = "None";
    AmbientGenericPreset[AmbientGenericPreset["HugeMachine"] = 1] = "HugeMachine";
    AmbientGenericPreset[AmbientGenericPreset["BigMachine"] = 2] = "BigMachine";
    AmbientGenericPreset[AmbientGenericPreset["Machine"] = 3] = "Machine";
    AmbientGenericPreset[AmbientGenericPreset["SlowFadeIn"] = 4] = "SlowFadeIn";
    AmbientGenericPreset[AmbientGenericPreset["FadeIn"] = 5] = "FadeIn";
    AmbientGenericPreset[AmbientGenericPreset["QuickFadeIn"] = 6] = "QuickFadeIn";
    AmbientGenericPreset[AmbientGenericPreset["SlowPulse"] = 7] = "SlowPulse";
    AmbientGenericPreset[AmbientGenericPreset["Pulse"] = 8] = "Pulse";
    AmbientGenericPreset[AmbientGenericPreset["QuickPulse"] = 9] = "QuickPulse";
    AmbientGenericPreset[AmbientGenericPreset["SlowOscillator"] = 10] = "SlowOscillator";
    AmbientGenericPreset[AmbientGenericPreset["Oscillator"] = 11] = "Oscillator";
    AmbientGenericPreset[AmbientGenericPreset["QuickOscillator"] = 12] = "QuickOscillator";
    AmbientGenericPreset[AmbientGenericPreset["GrungePitch"] = 13] = "GrungePitch";
    AmbientGenericPreset[AmbientGenericPreset["VeryLowPitch"] = 14] = "VeryLowPitch";
    AmbientGenericPreset[AmbientGenericPreset["LowPitch"] = 15] = "LowPitch";
    AmbientGenericPreset[AmbientGenericPreset["HighPitch"] = 16] = "HighPitch";
    AmbientGenericPreset[AmbientGenericPreset["VeryHighPitch"] = 17] = "VeryHighPitch";
    AmbientGenericPreset[AmbientGenericPreset["ScreamingPitch"] = 18] = "ScreamingPitch";
    AmbientGenericPreset[AmbientGenericPreset["OscillateSpinUpDown"] = 19] = "OscillateSpinUpDown";
    AmbientGenericPreset[AmbientGenericPreset["PulseSpinUpDown"] = 20] = "PulseSpinUpDown";
    AmbientGenericPreset[AmbientGenericPreset["RandomPitch"] = 21] = "RandomPitch";
    AmbientGenericPreset[AmbientGenericPreset["RandomPitchFast"] = 22] = "RandomPitchFast";
    AmbientGenericPreset[AmbientGenericPreset["IncrementalSpinup"] = 23] = "IncrementalSpinup";
    AmbientGenericPreset[AmbientGenericPreset["Alien"] = 24] = "Alien";
    AmbientGenericPreset[AmbientGenericPreset["Bizzare"] = 25] = "Bizzare";
    AmbientGenericPreset[AmbientGenericPreset["PlanetX"] = 26] = "PlanetX";
    AmbientGenericPreset[AmbientGenericPreset["Haunted"] = 27] = "Haunted";
})(AmbientGenericPreset || (exports.AmbientGenericPreset = AmbientGenericPreset = {}));
var AmbientGenericSpawnFlags;
(function (AmbientGenericSpawnFlags) {
    AmbientGenericSpawnFlags[AmbientGenericSpawnFlags["PlayEverywhere"] = 1] = "PlayEverywhere";
    AmbientGenericSpawnFlags[AmbientGenericSpawnFlags["SmallRadius"] = 2] = "SmallRadius";
    AmbientGenericSpawnFlags[AmbientGenericSpawnFlags["MediumRadius"] = 4] = "MediumRadius";
    AmbientGenericSpawnFlags[AmbientGenericSpawnFlags["LargeRadius"] = 8] = "LargeRadius";
    AmbientGenericSpawnFlags[AmbientGenericSpawnFlags["StartSilent"] = 16] = "StartSilent";
    AmbientGenericSpawnFlags[AmbientGenericSpawnFlags["NotToggled"] = 32] = "NotToggled";
})(AmbientGenericSpawnFlags || (exports.AmbientGenericSpawnFlags = AmbientGenericSpawnFlags = {}));
var ButtonTargetSpawnFlags;
(function (ButtonTargetSpawnFlags) {
    ButtonTargetSpawnFlags[ButtonTargetSpawnFlags["UseActivates"] = 1] = "UseActivates";
    ButtonTargetSpawnFlags[ButtonTargetSpawnFlags["StartOn"] = 2] = "StartOn";
})(ButtonTargetSpawnFlags || (exports.ButtonTargetSpawnFlags = ButtonTargetSpawnFlags = {}));
var CyclerWeaponTriggerCondition;
(function (CyclerWeaponTriggerCondition) {
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["NoTrigger"] = 0] = "NoTrigger";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["SeePlayerMadAtPlayer"] = 1] = "SeePlayerMadAtPlayer";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["TakeDamage"] = 2] = "TakeDamage";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["HalfHealthRemaining"] = 3] = "HalfHealthRemaining";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["Death"] = 4] = "Death";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["HearWorld"] = 7] = "HearWorld";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["HearPlayer"] = 8] = "HearPlayer";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["HearCombat"] = 9] = "HearCombat";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["SeePlayerUnconditional"] = 10] = "SeePlayerUnconditional";
    CyclerWeaponTriggerCondition[CyclerWeaponTriggerCondition["SeePlayerNotInCombat"] = 11] = "SeePlayerNotInCombat";
})(CyclerWeaponTriggerCondition || (exports.CyclerWeaponTriggerCondition = CyclerWeaponTriggerCondition = {}));
var EnvBeamSpawnFlags;
(function (EnvBeamSpawnFlags) {
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["StartOn"] = 1] = "StartOn";
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["Toggle"] = 2] = "Toggle";
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["RandomStrike"] = 4] = "RandomStrike";
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["Ring"] = 8] = "Ring";
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["StartSparks"] = 16] = "StartSparks";
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["EndSparks"] = 32] = "EndSparks";
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["DecalEnd"] = 64] = "DecalEnd";
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["FadeStart"] = 128] = "FadeStart";
    EnvBeamSpawnFlags[EnvBeamSpawnFlags["FadeEnd"] = 256] = "FadeEnd";
})(EnvBeamSpawnFlags || (exports.EnvBeamSpawnFlags = EnvBeamSpawnFlags = {}));
var ZHLTLightFlags;
(function (ZHLTLightFlags) {
    ZHLTLightFlags[ZHLTLightFlags["Normal"] = 0] = "Normal";
    ZHLTLightFlags[ZHLTLightFlags["EmbeddedFix"] = 1] = "EmbeddedFix";
    ZHLTLightFlags[ZHLTLightFlags["OpaqueBlockLight"] = 2] = "OpaqueBlockLight";
    ZHLTLightFlags[ZHLTLightFlags["OpaqueEmbeddedFix"] = 3] = "OpaqueEmbeddedFix";
    ZHLTLightFlags[ZHLTLightFlags["OpaqueConcaveFix"] = 6] = "OpaqueConcaveFix";
})(ZHLTLightFlags || (exports.ZHLTLightFlags = ZHLTLightFlags = {}));
var RenderEffect;
(function (RenderEffect) {
    RenderEffect[RenderEffect["Normal"] = 0] = "Normal";
    RenderEffect[RenderEffect["SlowPulse"] = 1] = "SlowPulse";
    RenderEffect[RenderEffect["FastPulse"] = 2] = "FastPulse";
    RenderEffect[RenderEffect["SlowWidePulse"] = 3] = "SlowWidePulse";
    RenderEffect[RenderEffect["FastWidePulse"] = 4] = "FastWidePulse";
    RenderEffect[RenderEffect["SlowFadeAway"] = 5] = "SlowFadeAway";
    RenderEffect[RenderEffect["FastFadeAway"] = 6] = "FastFadeAway";
    RenderEffect[RenderEffect["SlowBecomeSolid"] = 7] = "SlowBecomeSolid";
    RenderEffect[RenderEffect["FastBecomeSolid"] = 8] = "FastBecomeSolid";
    RenderEffect[RenderEffect["SlowStrobe"] = 9] = "SlowStrobe";
    RenderEffect[RenderEffect["FastStrobe"] = 10] = "FastStrobe";
    RenderEffect[RenderEffect["FasterStrobe"] = 11] = "FasterStrobe";
    RenderEffect[RenderEffect["SlowFlicker"] = 12] = "SlowFlicker";
    RenderEffect[RenderEffect["FastFlicker"] = 13] = "FastFlicker";
    RenderEffect[RenderEffect["ConstantGlow"] = 14] = "ConstantGlow";
    RenderEffect[RenderEffect["DistortModels"] = 15] = "DistortModels";
    RenderEffect[RenderEffect["HologramDistort"] = 16] = "HologramDistort";
})(RenderEffect || (exports.RenderEffect = RenderEffect = {}));
var RenderMode;
(function (RenderMode) {
    RenderMode[RenderMode["Normal"] = 0] = "Normal";
    RenderMode[RenderMode["Color"] = 1] = "Color";
    RenderMode[RenderMode["Texture"] = 2] = "Texture";
    RenderMode[RenderMode["Glow"] = 3] = "Glow";
    RenderMode[RenderMode["Solid"] = 4] = "Solid";
    RenderMode[RenderMode["Additive"] = 5] = "Additive";
})(RenderMode || (exports.RenderMode = RenderMode = {}));
const parseNumberArray = (a) => a.split(' ').map(b => parseFloat(b));
const parsers = {
    worldspawn: (e) => ({
        classname: 'worldspawn',
        wad: e.wad
            .split(';')
            .filter((a) => a.length)
            .map((w) => w.replace(/\\/g, '/')),
        mapversion: parseInt(e.mapversion),
        skyname: e.skyname,
        maxRange: parseFloat(e.MaxRange) || 8192,
        message: e.message || '',
        sounds: parseInt(e.sounds) || 0,
        light: parseInt(e.light) || 0,
        waveHeight: parseFloat(e.WaveHeight) || 0,
        startDark: parseInt(e.startdark) || 0,
        newUnit: parseInt(e.newunit) || 0,
        defaultTeam: parseInt(e.defaultteam) || 0,
        gameTitle: parseInt(e.gametitle) || 0
    }),
    aiscripted_sequence: (e) => ({
        classname: 'aiscripted_sequence',
        spawnflags: parseInt(e.spawnflags),
        m_iszEntity: e.m_iszEntity,
        m_iszPlay: e.m_iszPlay || '',
        m_flRadius: parseInt(e.m_flRadius) || 512,
        m_flRepeat: parseInt(e.m_flRepeat) || 0,
        m_fMoveTo: parseInt(e.m_fMoveTo) || 0,
        m_iFinishSchedule: parseInt(e.m_iFinishSchedule) || 0,
    }),
    ambient_generic: (e) => ({
        classname: 'ambient_generic',
        origin: parseNumberArray(e.origin),
        targetName: e.targetname,
        message: e.message,
        health: parseInt(e.health) || 10,
        preset: parseInt(e.preset) || 0,
        startVolume: parseInt(e.volstart) || 0,
        fadeIn: parseInt(e.fadein),
        fadeOut: parseInt(e.fadeout),
        pitch: parseInt(e.pitch),
        pitchStart: parseInt(e.pitchstart),
        spinUp: parseInt(e.spinup),
        spinDown: parseInt(e.spindown),
        lfoType: parseInt(e.lfotype),
        lfoRate: parseInt(e.lforate),
        lfoModPitch: parseInt(e.lfomodpitch),
        lfoModVolume: parseInt(e.lfomodvolume),
        cSpinUp: parseInt(e.cspinup),
        spawnFlags: parseInt(e.spawnflags)
    }),
    ammo_357: (e) => ({
        classname: 'ammo_357',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    ammo_9mmAR: (e) => ({
        classname: 'ammo_9mmAR',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    ammo_9mmbox: (e) => ({
        classname: 'ammo_9mmbox',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    ammo_9mmclip: (e) => ({
        classname: 'ammo_9mmclip',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    ammo_ARgrenades: (e) => ({
        classname: 'ammo_ARgrenades',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    ammo_buckshot: (e) => ({
        classname: 'ammo_buckshot',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    ammo_crossbow: (e) => ({
        classname: 'ammo_crossbow',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    ammo_gaussclip: (e) => ({
        classname: 'ammo_gaussclip',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    ammo_rpgclip: (e) => ({
        classname: 'ammo_rpgclip',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname || '',
        delay: parseInt(e.delay) || 0,
        killTarget: e.killtarget || '',
        spawnFlags: e.spawnflags || 0
    }),
    button_target: (e) => ({
        classname: 'button_target',
        target: e.target,
        master: e.master,
        renderEffect: parseInt(e.renderfx) || 0,
        renderMode: parseInt(e.rendermode) || 0,
        renderAmmount: parseInt(e.renderamt) || 255,
        renderColor: parseNumberArray(e.rendercolor || '0 0 0'),
        zhltLightFlags: parseInt(e.zhlt_lightflags) || 0,
        lightOrigin: e.light_origin,
        spawnFlags: parseInt(e.spawnflags) || 1
    }),
    cycler: (e) => ({
        classname: 'cycler',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        targetName: e.targetname,
        model: e.model,
        sequence: e.sequence || '',
        renderEffect: parseInt(e.renderfx) || 0,
        renderMode: parseInt(e.rendermode) || 0,
        renderAmmount: parseInt(e.renderamt) || 255,
        renderColor: parseNumberArray(e.rendercolor || '0 0 0')
    }),
    cycler_sprite: (e) => ({
        classname: 'cycler_sprite',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        targetName: e.targetname,
        model: e.model,
        framerate: parseInt(e.framerate || '10'),
        renderEffect: parseInt(e.renderfx) || 0,
        renderMode: parseInt(e.rendermode) || 0,
        renderAmmount: parseInt(e.renderamt) || 255,
        renderColor: parseNumberArray(e.rendercolor || '0 0 0')
    }),
    cyclear_weapon: (e) => ({
        classname: 'cycler_weapon',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        target: e.target,
        targetName: e.targetname,
        triggerTarget: e.TriggerTarget || '',
        triggerCondition: parseInt(e.TriggerCondition) || 0,
        model: e.model,
        sequence: e.sequence,
        renderEffect: parseInt(e.renderfx) || 0,
        renderMode: parseInt(e.rendermode) || 0,
        renderAmmount: parseInt(e.renderamt) || 255,
        renderColor: parseNumberArray(e.rendercolor || '0 0 0')
    }),
    cyclear_wreckage: (e) => ({
        classname: 'cycler_wreckage',
        origin: parseNumberArray(e.origin),
        angles: parseNumberArray(e.angles),
        targetName: e.targetname,
        model: e.model,
        framerate: parseInt(e.framerate) || 10,
        scale: parseFloat(e.scale) || 1.0,
        renderEffect: parseInt(e.renderfx) || 0,
        renderMode: parseInt(e.rendermode) || 0,
        renderAmmount: parseInt(e.renderamt) || 255,
        renderColor: parseNumberArray(e.rendercolor || '0 0 0')
    }),
    env_beam: (e) => ({
        classname: 'env_beam',
        renderEffect: parseInt(e.renderfx) || 0,
        renderMode: parseInt(e.rendermode) || 0,
        renderAmmount: parseInt(e.renderamt) || 255,
        renderColor: parseNumberArray(e.rendercolor || '0 0 0'),
        radius: parseFloat(e.Radius) || 256,
        life: parseInt(e.life) || 1,
        boltWidth: parseInt(e.BoltWidth) || 20,
        noiseAmplitude: parseInt(e.NoiseAmplitude) || 0,
        texture: e.texture || 'sprites/laserbeam.spr',
        textureScroll: parseInt(e.TextureScroll) || 35,
        frameRate: parseInt(e.framerate) || 0,
        frameStart: parseInt(e.framestart) || 0,
        strikeTime: parseInt(e.StrikeTime) || 1,
        damage: parseInt(e.damage) || 1,
        spawnFlags: parseInt(e.spawnflags)
    })
};
class BspEntityParser {
    static parse(entities) {
        const arr = [];
        for (let i = 0; i < entities.length; ++i) {
            const e = entities[i];
            if (!e.classname) {
                arr.push({
                    classname: '!',
                    data: e
                });
            }
            if (parsers[e.classname]) {
                arr.push(parsers[e.classname](e));
            }
            else {
                arr.push({
                    classname: '?',
                    originalClassname: e.classname,
                    data: e
                });
            }
        }
        return arr;
    }
}
exports.BspEntityParser = BspEntityParser;
